import { patientMap } from "./patient";
import { internmentMap } from "./internment";
import { hospitalizationPermitMap } from "./hospitalizationPermit";
import { deceaseMap } from "./decease";
import { bedMap } from "./bed";
import { lastAppointmentMap } from "./lastAppointment";
import { latestMetricsMap } from "./latestMetrics";
import { surgicalAttendanceMap } from "./surgicalAttendance";
import { timestampsMap } from "./timestamps";

export const attendanceMap: GenericObject = {
	tempo_unidade: "timeUnit",
	active_hospitalization_permit: {
		__key: "activeHospitalizationPermit",
		...hospitalizationPermitMap,
	},
	paciente: {
		__key: "patient",
		...patientMap,
	},
	internament: {
		__key: "internment",
		...internmentMap,
	},
	decease: deceaseMap,
	bed: bedMap,
	paciente_nome: "patientName",
	inicio_atendimento: "startAttendance",
	motivo_atendimento: "reasonAttendance",
	paciente_cpf: "patientIdentifier",
	paciente_cns: "patientNationalHealthCard",
	classif_risco: "riskClassification",
	paciente_id: "patientId",
	idade_carbon: "carbonAge",
	imagem: "image",
	last_appointment: {
		__key: "lastAppointment",
		...lastAppointmentMap,
	},
	latest_metrics: {
		__key: "latestMetrics",
		...latestMetricsMap,
	},
	surgical_attendance: {
		__key: "surgicalAttendance",
		...surgicalAttendanceMap,
	},
	...timestampsMap,
};
